import Mainvisual from "./top/mv";
import Search from "./top/search";
import FAQ from "./top/faq";
import FloatNav from "./top/floatnav";
import PointSlide from "./top/pointSlide";

document.addEventListener("DOMContentLoaded", () => {
    const mv = new Mainvisual();
    const search = new Search();
    const faq = new FAQ();
    const floatnav = new FloatNav();
    const pointslide = new PointSlide();
});
